import React from 'react';
import { Box, Typography } from '@mui/material';
import './StatsCard.css';

const StatsCard = ({ title, value, changePercentage, isPositive, suffix = '', comparisonText }) => {
  return (
    <Box className="stats-card">
      <Typography variant="body1" className="stats-card-title">
        {title}
      </Typography>
      <Box className="stats-card-content">
        <Typography variant="h4" className="stats-card-value">
          {suffix && suffix !== 'hrs' && suffix !== 'Koins' ? suffix : ''}
          {value || 0}
          {suffix === 'hrs' ? ` ${suffix}` : ''}
          {suffix === 'Koins' ? ` ${suffix}` : ''}
        </Typography>
        <Typography
          variant="body2"
          className={`stats-percentage ${isPositive ? 'positive' : 'negative'}`}
        >
          {isPositive ? '↑' : '↓'} {Math.abs(changePercentage)}% {comparisonText || 'vs last month'}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatsCard;
